<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <div>
            <b-row class="mb-3">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @change="consulta_corredor()">
                    <b-form-input type="number" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button @click="buscarcorredor()" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="4">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col sm="2">
                <label>Cargo</label>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                    <b-form-select
                        :options="cargos"
                        v-model="datosFormulario.Cargo">
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-1">
              <b-col sm="2">
                <label>Estado</label>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                    <b-form-select
                        :options="estado"
                        v-model="datosFormulario.Estado">
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col sm="2">
                <label>Ver</label>
              </b-col>
              
              <b-col sm="3">
                <b-form-checkbox-group
                  v-model="selectedDire"
                  :options="ckdDire"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>
              
            </b-row>
          </div>
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button v-if="hasCorredor" variant="primary" @click="nuevoContacto()">Agregar Contacto</b-button>
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
    
                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="gicdireccionlegal"
                  label="Dirección Legal"
                  align="left"
                  width="200">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="gicciudadlegal"
                  align="left"
                  label="Ciudad Legal"
                  width="120">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="giccomunalegal"
                  label="Comuna Legal"
                  align="left"
                  width="120">
                </el-table-column>

                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="gicdireccionparticular"
                  label="Dirección Particular"
                  align="left"
                  width="200">
                </el-table-column>
                
                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="gicciudad"
                  align="left"
                  label="Ciudad Particular"
                  width="120">
                </el-table-column>
                
                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="giccomuna"
                  label="Comuna Particular"
                  align="left"
                  width="120">
                </el-table-column>

                <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      title="Búsqueda de Corredor"
      scrollable
      cancel-title="Cerrar"
      class="modal-success"
      size="lg"
      v-model="modalCorredor"
      @cancel="modalCorredor = false"
      hide-footer
    >
      <b-row> 
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters3[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      <b-row>
      <b-col lg="12">             
        <div ref="refTable">
          <data-tables ref="refTable1"
            :data="data2"
            name="table"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters3"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table"
            >
          <el-table-column
            v-for="title in titles3"
            :min-width="title.minwidth" 
            :prop="title.prop"
            :label='title.label'
            :key="title.label"
            :align="title.align"
            sortable="custom"
            :formatter="formatter"
            name="table"
            class="table-responsive"
            >

            <template slot-scope="scope">  
              <div v-if="title.prop == 'corredor'">    
                <b-link type="text" v-if="scope.row.codcorredor > 1" @click="selecciona_corredor(scope.row.codcorredor,scope.row.corredor,scope.row.idnacion)">{{scope.row.corredor}}</b-link>
                  <p v-else >{{scope.row.corredor}}</p>
                  </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
            </template>  

          </el-table-column>
          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>  
  
  <b-modal
      id="modificacion-contacto"
      title="Modificación Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="handleOk"
      @cancel="modalModificar = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicnombrecorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Rut Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicrutcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Código Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.giccodcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Estado del Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicestadocorredor">
            </b-form-input> 
            <!-- <b-form-radio v-model="datosFormularioModal.gicestado" value="Vigente">Vigente</b-form-radio>
            <b-form-radio v-model="datosFormularioModal.gicestado" value="No Vigente">No Vigente</b-form-radio> -->
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicnomcontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Apellido Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicapellcontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Cargo Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="cargos"
                  v-model="datosFormularioModal.giccargo">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState"
            >
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.gicmail"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Fijo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 229999999"
                  title="Ingrese formato: 56 229999999"
                  v-model="datosFormularioModal.gictelefonofijo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Móvil</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 229999999"
                  title="Ingrese formato: 56 229999999"
                  v-model="datosFormularioModal.gictelefonomovil">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Comercial Crédito</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactocomcred"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Ventas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactoventas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Siniestro</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactosiniestro"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Garantía</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactogarantia"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Recuperos</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactorecuperos"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicdireccionlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      
      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.gicciudadlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.giccomunalegal">
              </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicdireccionparticular">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicciudad">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.giccomuna">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Fecha Cumpleaños</label>
        </b-col>
       <b-col class="col-sm-per" sm ="8">
                                
          <b-form-datepicker
              id="idfedenuncio"
              v-model="datosFormularioModal.gicfechacumpleanos"
              :default-value="this.datosFormularioModal.gicfechacumpleanos"
              size="sm"
              :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
              locale="ES"
              placeholder="Seleccione fecha"
              >
          </b-form-datepicker>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Categoría Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select 
                  :options="categorias" 
                  v-model="datosFormularioModal.giccategoriacontacto">
              </b-form-select> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Observaciones</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicobservacion">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicultimamodificacion">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicusuario">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>

    <!-- Agregar Contacto -->
    <b-modal
      id="nuevo-contacto"
      title="Nuevo Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="handleOk"
      @cancel="modalNuevo = false"
    >
     <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicnombrecorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Rut Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicrutcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Código Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.giccodcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Estado del Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicestadocorredor">
              </b-form-input> 
            <!-- <b-form-radio v-model="datosFormularioModal.gicestado" value="Vigente">Vigente</b-form-radio>
            <b-form-radio v-model="datosFormularioModal.gicestado" value="No Vigente">No Vigente</b-form-radio> -->
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicnomcontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Apellido Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicapellcontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Cargo Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="cargos"
                  v-model="datosFormularioModal.giccargo">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.gicmail"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Fijo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 229999999"
                  title="Ingrese formato: 56 229999999"
                  v-model="datosFormularioModal.gictelefonofijo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Móvil</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 999999999"
                  title="Ingrese formato: 56 999999999"
                  v-model="datosFormularioModal.gictelefonomovil">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Comercial Crédito</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactocomcred"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Ventas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactoventas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Siniestro</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactosiniestro"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Garantía</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactogarantia"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contacto Recuperos</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.giccontactorecuperos"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicdireccionlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
     
      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.gicciudadlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.giccomunalegal">
              </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicdireccionparticular">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicciudad">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Particular</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.giccomuna">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Fecha Cumpleaños</label>
        </b-col>
       
        <b-col class="col-sm-per" sm ="8">
                                
          <b-form-datepicker
              id="idfedenuncio"
              v-model="datosFormularioModal.gicfechacumpleanos"
              :default-value="this.datosFormularioModal.gicfechacumpleanos"
              size="sm"
              :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
              locale="ES"
              placeholder="Seleccione fecha"
              >
          </b-form-datepicker>
        </b-col>

      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Categoría Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="categorias"
                  v-model="datosFormularioModal.giccategoriacontacto">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Observaciones</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.gicobservacion">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <!-- <b-row class="my-1">
        <b-col sm="4">
          <label>Estado</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="estado"
                  v-model="datosFormularioModal.estado">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row> -->

      <!-- <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicultimamodificacion">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicusuario">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row> -->
      </b-form>
    </b-modal>
  
    <!-- Eliminar -->
    <b-modal
      title="Eliminar Contacto"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar();"
      @cancel="modalEliminar = false"
    >
        Se eliminara el siguiente contacto:
        <br><br>
        Corredor: {{datosFormularioModal.gicnombrecorredor}} 
        <br>
        Contacto: {{datosFormularioModal.gicnomcontacto}} {{datosFormularioModal.gicapellcontacto}}
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConCorredor  from "@/components/services/apiConCorredor";
import apiBaseCorredor from "@/components/services/apiBaseCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalModificar : false,
      modalEliminar : false,
      modalNuevo : false,
      modalCorredor : false,     
      hasCorredor : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      ckdDire: [
          { item:  'DL', name: 'Dirección Legal' },
          { item:  'DP', name: 'Dirección Particular' }
        ],
      
      chkDireccion:false,

      data: [],
      data2: [],
      nombreexcel: "BaseCorredores",
      titles: [
        {
          prop: "gicnombrecorredor",
          label: "Nombre Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "gicrutcorredor",
          label: "Rut Corredor",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "giccodcorredor",
          label: "Código Corredor",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "gicestadocorredor",
          label: "Estado del Corredor",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "gicnomcontacto",
          label: "Nombre Contacto",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "gicapellcontacto",
          label: "Apellido Contacto",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "giccargo",
          label: "Cargo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "gicmail",
          label: "Mail Contacto",
          align: "left",
          minwidth:'140'
        },
        {
          prop: "gictelefonofijo",
          label: "Teléfono Fijo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "gictelefonomovil",
          label: "Teléfono Móvil",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccontactocomcred",
          label: "Contacto Comercial Crédito",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccontactoventas",
          label: "Contacto Ventas",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccontactosiniestro",
          label: "Contacto Siniestro",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccontactogarantia",
          label: "Contacto Garantía",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccontactorecuperos",
          label: "Contacto Recuperos",
          align: "center",
          minwidth:'100'
        },
        {
          // prop: "gicfechacumpleanos",
          prop: "diamescumpleanos",
          label: "Fecha Cumpleaños",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "giccategoriacontacto",
          label: "Categoría Contacto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "gicobservacion",
          label: "Observación",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "gicultimamodificacion",
          label: "Última Modificación",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "gicusuario",
          label: "Usuario",
          align: "center",
          minwidth:'80'
        }      
      ],

      titles3: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "center",
          minwidth:'120'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          gicidinfcorr: "",
          gicnombrecorredor: "",
          gicrutcorredor: "",
          giccodcorredor: "",
          gicnomcontacto: "",
          gicapellcontacto: "",
          giccargo: "",
          gicmail: "",
          gictelefonofijo: "",
          gictelefonomovil: "",
          giccontactocomcred: "",
          giccontactoventas: "",
          giccontactosiniestro: "",
          giccontactogarantia: "",
          giccontactorecuperos: "",
          gicdireccionlegal: "",
          gicciudadlegal: "",
          giccomunalegal: "",
          gicdireccionparticular: "",
          gicciudad: "",
          giccomuna: "",
          gicfechacumpleanos: "",
          giccategoriacontacto: "",
          gicobservacion: "",
          gicultimamodificacion: "",
          gicusuario: "",
          gicestado: "",
          gicestadocorredor: "",
          gicultimamodedocorr: "",
          gicusumodedocorr: ""
      },

      filters3: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],
      
      mostrarFechas: true,
      datosFormulario: {
          codCorredor: "",
          IdNacionCorred: "",
          NombreCorred: "",
          direccionlegal: "",
          ciudadlegal: "",
          comunalegal: ""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      nameState: null,
      submittedNames: [],
      
      valEjecutivos: [],
      paises: [],
      ciudades: [],
      comunas: [],
      cargos: [],
      estado: [],
      categorias: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {

    checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      resetModal() {
        this.name = ''
        this.nameState = null
      },

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault();  
        // Trigger submit handler
        this.handleSubmit();
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        this.submittedNames.push(this.datosFormularioModal)
        // Hide the modal manually
        this.$nextTick(() => {
         // this.saveRow(); 
          this.verificaDatosContacto();
          //this.$bvModal.hide('nuevo-contacto');
          //this.$bvModal.hide('modificacion-contacto');
        })
      },

     verificaDatosContacto()
            {  let rows = this.datosFormularioModal;
               var existe_nombre = '';
               var existe_correo = '';
               var idCorredor = rows.gicidinfcorr;
               if (idCorredor === '' || idCorredor === undefined)
                  {
                   idCorredor = 0;}
              //verifico si existen casos con la llave indicada
              var usuario = this.$session.get("mail");
              return apiBaseCorredor.verificarDatosContacto(usuario, 
                                                        idCorredor,
                                                        rows.gicnomcontacto,
                                                        rows.gicapellcontacto,
                                                        rows.gicmail)
                    .then(response => {
                      
                      existe_nombre = response.data.args_out.existe_nombre;
                      existe_correo = response.data.args_out.existe_correo;

                     
                     if(existe_nombre != '' && existe_correo != '' && 
                        existe_nombre != undefined && existe_correo != undefined){   
              
                          if(existe_nombre === existe_correo)                   
                             {this.crearNotificacion1("Aviso","El contacto ingresado ya existe, por favor verificar."
                                               + "<br>" + "Se repite el nombre de contacto: " 
                                               + rows.gicnomcontacto  + " " + rows.gicapellcontacto
                                               + "<br>" + "Se repite el correo: "
                                               + rows.gicmail
                                               + "<br>" + "Lo anterior, en los contactos del corredor: "
                                               + response.data.args_out.existe_nombre, "error");}
                          else{this.crearNotificacion1("Aviso","El contacto ingresado ya existe, por favor verificar."
                                               + "<br>" + "Se repite el nombre de contacto: " 
                                               + rows.gicnomcontacto  + " " + rows.gicapellcontacto
                                               + "<br>" + "Se repite el correo: "
                                               + rows.gicmail
                                               + "<br>" + "Lo anterior, en los contactos del corredor: "
                                               + response.data.args_out.existe_nombre + "  y : " 
                                               + response.data.args_out.existe_correo , "error");}                     
                       return ;}
                     else if (existe_nombre != '' && existe_nombre != undefined){
                       this.crearNotificacion1("Aviso","El contacto ingresado ya existe, por favor verificar."
                                               + "<br>" + "Se repite el nombre de contacto: " 
                                               + rows.gicnomcontacto  + " " + rows.gicapellcontacto
                                               + "<br>" + "Lo anterior, en los contactos del corredor: "
                                               + response.data.args_out.existe_nombre , "error");
                       return ;}       
                     else if (existe_correo != '' && existe_correo != undefined){
                       this.crearNotificacion1("Aviso","El contacto ingresado ya existe, por favor verificar."
                                               + "<br>" + "Se repite el correo: " 
                                               + rows.gicmail
                                               + "<br>" + "Lo anterior, en los contactos del corredor: "
                                               + response.data.args_out.existe_correo , "error");
                       return ;}
                     else                              
                         {this.saveRow();} 
                  // terminar barra de progreso
                  this.$Progress.finish();
                 }
                 )
             .catch(error => (console.log(error)))
                
            },  

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          var obj2 = new Object();
          obj2.tooltip = "Eliminar";
          obj2.id = 2;
          obj2.name="Eliminar";
          obj2.icon = "fa fa-eraser";
          obj2.type = "success";
          obj2.handler= _ => {
              this.$session.start();
              this.eliminarContacto(row);
          }
          botones.push(obj2);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.codCorredor ="";
      this.datosFormulario.NombreCorred ="";
      this.datosFormulario.IdNacionCorred ="";
      this.datosFormulario.Cargo ="";
      this.datosFormulario.Estado ="";
      this.hasCorredor = false;
      
      return apiBaseCorredor
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.codCorredor='';
          this.datosFormulario.Cargo = 'TOD';
          this.datosFormulario.Estado = 'Vigente';

          //carga de listados
          this.paises = this.llenaArrayLista(response.data.pais, 'codigo', 'nombre', false);
          this.ciudades = this.llenaArrayLista(response.data.ciudad, 'codigo', 'nombre', false);
          this.comunas = this.llenaArrayLista(response.data.comuna, 'codigo', 'nombre', false);
          this.cargos = this.llenaArrayLista(response.data.cargo, 'codigo', 'nombre', false);
          this.estado = this.llenaArrayLista(response.data.estado, 'codigo', 'nombre', false);
          this.categorias = this.llenaArrayLista(response.data.categoria, 'codigo', 'nombre', false);

          this.datosFormularioEstado = response.data.festado;
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;
      this.datosFormulario.Cargo == 'Todos' ? '' : this.datosFormulario.Cargo; 
      this.datosFormulario.Estado == 'Vigente'? '' : this.datosFormulario.Estado;
      
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;
      var p_cargo= this.datosFormulario.Cargo == 'Vigente' ? 'Vigente' : this.datosFormulario.Cargo; 
      var p_estado= this.datosFormulario.Estado == 'TOD' ? 'TOD' : this.datosFormulario.Estado; 

      return apiBaseCorredor
      .recuperar(p_email, p_corredor, p_cargo, p_estado)
          .then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "gicfechacumpleanos"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Rut Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Código Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado del Corredor" + "</td>\n";
        
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Apellido Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Cargo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Mail Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Teléfono Fijo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Teléfono Móvil" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contacto Comercial Crédito" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contacto Ventas" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contacto Siniestro" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contacto Garantía" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contacto Recuperos" + "</td>\n";
        if (this.selectedDire.includes('DL')){
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Dirección Legal" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ciudad" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comuna" + "</td>\n";
        }
        if (this.selectedDire.includes('DP')){
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Dirección Particular" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ciudad" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comuna" + "</td>\n";
        }
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Fecha Cumpleaños" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Categoría Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Observación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";

      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      let diadiapol = '';
      let decididor = '';
      for (var key in this.data) {
        if(this.data[key]["gicnomcontacto"] === undefined){ 
          this.data[key]["gicnomcontacto"] = "";
        }
        if(this.data[key]["gicapellcontacto"] === undefined){ 
          this.data[key]["gicapellcontacto"] = "";
        }
        if(this.data[key]["giccargo"] === undefined){ 
          this.data[key]["giccargo"] = "";
        }
        if(this.data[key]["gicmail"] === undefined){ 
          this.data[key]["gicmail"] = "";
        }
        if(this.data[key]["gictelefonofijo"] === undefined){ 
          this.data[key]["gictelefonofijo"] = "";
        }
        
        if(this.data[key]["gictelefonomovil"] == undefined){ 
          this.data[key]["gictelefonomovil"] = "";
        }
        if(this.data[key]["giccontactocomcred"] == undefined){ 
          this.data[key]["giccontactocomcred"] = "";
        }
        if(this.data[key]["giccontactoventas"] == undefined){ 
          this.data[key]["giccontactoventas"] = "";
        }
        if(this.data[key]["giccontactosiniestro"] == undefined){ 
          this.data[key]["giccontactosiniestro"] = "";
        }
        if(this.data[key]["giccontactogarantia"] == undefined){ 
          this.data[key]["giccontactogarantia"] = "";
        }
        if(this.data[key]["giccontactorecuperos"] == undefined){ 
          this.data[key]["giccontactorecuperos"] = "";
        }
        if(this.data[key]["gicdireccionlegal"] == undefined){ 
          this.data[key]["gicdireccionlegal"] = "";
        }
        if(this.data[key]["gicciudadlegal"] == undefined){ 
          this.data[key]["gicciudadlegal"] = "";
        }
        if(this.data[key]["giccomunalegal"] == undefined){ 
          this.data[key]["giccomunalegal"] = "";
        }
        if(this.data[key]["gicdireccionparticular"] == undefined){ 
          this.data[key]["gicdireccionparticular"] = "";
        }
        if(this.data[key]["gicciudad"] == undefined){ 
          this.data[key]["gicciudad"] = "";
        }
        if(this.data[key]["giccomuna"] == undefined){ 
          this.data[key]["giccomuna"] = "";
        }
        // if(this.data[key]["gicfechacumpleanos"] == undefined){ 
        //   this.data[key]["gicfechacumpleanos"] = "";
        // }
        if(this.data[key]["diamescumpleanos"] == undefined){ 
           this.data[key]["diamescumpleanos"] = "";
        }
        if(this.data[key]["giccategoriacontacto"] == undefined){ 
          this.data[key]["giccategoriacontacto"] = "";
        }
        if(this.data[key]["gicobservacion"] == undefined){ 
          this.data[key]["gicobservacion"] = "";
        }
        if(this.data[key]["gicultimamodificacion"] == undefined){ 
          this.data[key]["gicultimamodificacion"] = "";
        }
        if(this.data[key]["gicusuario"] == undefined){ 
          this.data[key]["gicusuario"] = "";
        }
        if(this.data[key]["gicestado"] == undefined){ 
          this.data[key]["gicestado"] = "";
        }
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicnombrecorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicrutcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccodcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicestadocorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicnomcontacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicapellcontacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccargo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicmail"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gictelefonofijo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gictelefonomovil"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccontactocomcred"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccontactoventas"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccontactosiniestro"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccontactogarantia"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccontactorecuperos"] + "</td>\n";
        if (this.selectedDire.includes('DL')){
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicdireccionlegal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicciudadlegal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccomunalegal"] + "</td>\n";
        }
        if (this.selectedDire.includes('DP')){
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicdireccionparticular"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicciudad"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccomuna"] + "</td>\n";
        }
       // cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.convierteFecha(this.data[key]["gicfechacumpleanos"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["diamescumpleanos"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccategoriacontacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicobservacion"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["gicultimamodificacion"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicusuario"] + "</td>\n";
        
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    selecciona_corredor(p_codcorredor, p_corredor, p_idnacion) {
       this.datosFormulario.codCorredor = p_codcorredor;
       this.datosFormulario.NombreCorred = p_corredor;
       this.datosFormulario.IdNacionCorred = p_idnacion;
       this.modalCorredor = false;      
    },

    buscarcorredor: function(){
      this.$Progress.start();
      var p_email= this.$session.get("mail");
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      return apiConCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasCorredor = false;
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
          return false;
      }
      return apiBaseCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         var InfoCorredorDir = response.data.res1;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["peridnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["pernombreimp"];
          }
           for (var i = 0; i < InfoCorredorDir.length; i++) {
            this.datosFormulario.direccionlegal = InfoCorredorDir[i]["gicdireccionlegal"];
            this.datosFormulario.ciudadlegal = InfoCorredorDir[i]["gicciudadlegal"];
            this.datosFormulario.comunalegal = InfoCorredorDir[i]["giccomunalegal"];
          }
          this.hasCorredor = true;
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    nuevoContacto: function(){
      this.datosFormularioModal.gicidinfcorr = "";
      this.datosFormularioModal.gicnombrecorredor = this.datosFormulario.NombreCorred;
      this.datosFormularioModal.gicrutcorredor = this.datosFormulario.IdNacionCorred;
      this.datosFormularioModal.giccodcorredor = this.datosFormulario.codCorredor;
      this.datosFormularioModal.gicestadocorredor = this.datosFormulario.Estado;
      
      this.datosFormularioModal.gicnomcontacto = "";
      this.datosFormularioModal.gicapellcontacto = "";
      this.datosFormularioModal.giccargo = "";
      this.datosFormularioModal.gicmail = "";
      this.datosFormularioModal.gictelefonofijo = "";
      this.datosFormularioModal.gictelefonomovil = "";
      this.datosFormularioModal.giccontactocomcred = "";
      this.datosFormularioModal.giccontactoventas = "";
      this.datosFormularioModal.giccontactosiniestro = "";
      this.datosFormularioModal.giccontactogarantia = "";
      this.datosFormularioModal.giccontactorecuperos = "";
      
      this.datosFormularioModal.gicdireccionlegal = this.datosFormulario.direccionlegal;
      this.datosFormularioModal.gicciudadlegal = this.datosFormulario.ciudadlegal;
      this.datosFormularioModal.giccomunalegal = this.datosFormulario.comunalegal;
      
      this.datosFormularioModal.gicdireccionparticular = "";
      this.datosFormularioModal.gicciudad = "";
      this.datosFormularioModal.giccomuna = "";
      this.datosFormularioModal.gicfechacumpleanos = "";
      this.datosFormularioModal.giccategoriacontacto = "";
      this.datosFormularioModal.gicobservacion = "";
      
      // this.datosFormularioModal.gicultimamodificacion = this.data[key]["gicultimamodificacion"];
      // this.datosFormularioModal.gicusuario = this.$session.get("usuarioInterno");
      // // this.datosFormularioModal.gicestado = this.datosFormulario.addestado;
      this.modalNuevo = true;
    },

    modificarContacto: function( row ){
      this.datosFormularioModal.gicidinfcorr = row.gicidinfcorr;
      this.datosFormularioModal.gicnombrecorredor = row.gicnombrecorredor;
      this.datosFormularioModal.gicrutcorredor = row.gicrutcorredor;
      this.datosFormularioModal.giccodcorredor = row.giccodcorredor;
      this.datosFormularioModal.gicnomcontacto = row.gicnomcontacto;
      this.datosFormularioModal.gicapellcontacto = row.gicapellcontacto;
      this.datosFormularioModal.giccargo = row.giccargo;
      this.datosFormularioModal.gicmail = row.gicmail;
      this.datosFormularioModal.gictelefonofijo = row.gictelefonofijo;
      this.datosFormularioModal.gictelefonomovil = row.gictelefonomovil;
      this.datosFormularioModal.giccontactocomcred = row.giccontactocomcred;
      this.datosFormularioModal.giccontactoventas = row.giccontactoventas;
      this.datosFormularioModal.giccontactosiniestro = row.giccontactosiniestro;
      this.datosFormularioModal.giccontactogarantia = row.giccontactogarantia;
      this.datosFormularioModal.giccontactorecuperos = row.giccontactorecuperos;
      this.datosFormularioModal.gicdireccionlegal = row.gicdireccionlegal;
      this.datosFormularioModal.gicciudadlegal = row.gicciudadlegal;
      this.datosFormularioModal.giccomunalegal = row.giccomunalegal;
      this.datosFormularioModal.gicdireccionparticular = row.gicdireccionparticular;
      this.datosFormularioModal.gicciudad = row.gicciudad;
      this.datosFormularioModal.giccomuna = row.giccomuna;
      this.datosFormularioModal.gicfechacumpleanos = row.gicfechacumpleanos;
      this.datosFormularioModal.giccategoriacontacto = row.giccategoriacontacto;
      this.datosFormularioModal.gicobservacion = row.gicobservacion;
      this.datosFormularioModal.gicultimamodificacion = row.gicultimamodificacion;
      this.datosFormularioModal.gicusuario = row.gicusuario;
      this.datosFormularioModal.gicestado = row.gicestado;
      this.datosFormularioModal.gicestadocorredor = row.gicestadocorredor
      this.datosFormularioModal.gicultimamodedocorr = row.gicultimamodedocorr
      this.datosFormularioModal.gicusumodedocorr = row.gicusumodedocorr
      this.modalModificar = true;
    },

    saveRow() { 
      let rows = this.datosFormularioModal;
      var p_id = rows.gicidinfcorr;

      var vestado="";
      var vMensaje="";
      
      if ((parseInt(p_id)>0) && (this.modalModificar)){
        //Modificar
        return apiBaseCorredor
          .editar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.gicidinfcorr,
            rows.gicnomcontacto,
            rows.gicapellcontacto,
            rows.giccargo,
            rows.gicmail,
            rows.gictelefonofijo,
            rows.gictelefonomovil,
            rows.giccontactocomcred,
            rows.giccontactoventas,
            rows.giccontactosiniestro,
            rows.giccontactogarantia,
            rows.giccontactorecuperos,
            rows.gicdireccionparticular,
            rows.gicciudad,
            rows.giccomuna,
            rows.gicfechacumpleanos,
            rows.giccategoriacontacto,
            rows.gicestado,
            rows.gicobservacion,
            rows.gicultimamodificacion,
            rows.gicusuario
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha editado el contacto.",
                "success"
              );    
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }

            this.$nextTick(() => {
                 this.$bvModal.hide('nuevo-contacto');
                 this.$bvModal.hide('modificacion-contacto');
             })
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      }else{
        return apiBaseCorredor  
          .insertar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.giccodcorredor,
            rows.gicnomcontacto,
            rows.gicapellcontacto,
            rows.giccargo,
            rows.gicmail,
            rows.gictelefonofijo,
            rows.gictelefonomovil,
            rows.giccontactocomcred,
            rows.giccontactoventas,
            rows.giccontactosiniestro,
            rows.giccontactogarantia,
            rows.giccontactorecuperos,
            rows.gicdireccionparticular,
            rows.gicciudad,
            rows.giccomuna,
            rows.gicfechacumpleanos,
            rows.giccategoriacontacto,
            rows.gicestado,
            rows.gicobservacion,
            rows.gicultimamodificacion,
            rows.gicusuario
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Se ha guardado el nuevo contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
             this.$nextTick(() => {
                 this.$bvModal.hide('nuevo-contacto');
                 this.$bvModal.hide('modificacion-contacto');
             })
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
      }
    },
    
    eliminarContacto(row){
      this.datosFormularioModal.gicidinfcorr = row.gicidinfcorr;
      this.datosFormularioModal.gicnomcontacto = row.gicnomcontacto;
      this.datosFormularioModal.gicapellcontacto = row.gicapellcontacto;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
      return apiBaseCorredor
          .eliminar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.gicidinfcorr
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
